import { render, staticRenderFns } from "./ProductReviewForm.vue?vue&type=template&id=f91d340e&"
import script from "./ProductReviewForm.vue?vue&type=script&lang=js&"
export * from "./ProductReviewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports